export const environment = {
  production: false,
  apiUrl: 'http://localhost:3000/api',
  cmsUrl: 'http://localhost:1337', // Legacy Strapi CMS URL (kept for backward compatibility)
  sanityUrl: 'https://9bh09p3k.api.sanity.io/v2023-05-03/data/query/production', // Sanity API URL
  useSanity: true, // Flag to use Sanity instead of Strapi
  syncTranslationsWithCms: false, // Set to true to sync translations from CMS
  blogOnly: true, // Flag to use CMS only for blog posts, not for products
  brevo: {
    apiKey:
      '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', // Replace with actual Brevo API key
  },
  firebase: {
    apiKey: 'AIzaSyCK35e-4U1xzRXahKbcK_bYgsN9iU-syEM',
    authDomain: 'mzm-homes.firebaseapp.com',
    projectId: 'mzm-homes',
    storageBucket: 'mzm-homes.firebasestorage.app',
    messagingSenderId: '571611271567',
    appId: '1:571611271567:web:fac08efd46d99ab1c6bbfa',
    measurementId: 'G-PWTZ45HPSL',
  },
  sanity: {
    projectId: '9bh09p3k',
    dataset: 'production',
    apiVersion: '2023-05-03',
  },
  dataForSeo: {
    login: 'info@mzmhomes.com',
    password: '6dc2e5d67a9e02e1',
  },
};
